<template>
  <div
    class="views-page is-flex is-flex-direction-column px-5 pt-3 pb-5"
    style="min-height: 50vh"
  >
    <div
      class="info-line"
      :class="GetMessagesData.main_color"
    />
    <b-loading
      :is-full-page="false"
      v-model="isLoading"
      :can-cancel="false"
    />
    <div class="has-text-right mb-4">
      <button
        class="button is-info"
        @click="exportPDF"
      >Скачать PDF</button>
    </div>
    <div v-html="getMarked()" class="content"></div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex"
import { Remarkable } from "remarkable"

export default {
  props: ["device_id", "report_id"],
  data() {
    return {
      content: "",
      isLoading: true,
      isExporting: false,
    }
  },
  computed: mapGetters(["GetMessagesData"]),
  created() {
    // this.ChangeNavName("Архивные сообщения")
    this.FetchMessages(this.device_id)
    this.fetchMessages()
  },
  methods: {
    ...mapActions(["FetchArchiveMsg", "FetchMessages"]),
    ...mapMutations(["ChangeNavName"]),
    getMarked() {
      let md = new Remarkable("full", {
        html: true,
        breaks: true,
        typographer: true,
      })
      return md.render(this.content)
    },
    async fetchMessages(page) {
      this.currentPage = page || 1
      this.isLoading = true
      try {
        const { data } = await this.$axios.get(`ai-request-sets/${this.report_id}/last`)
        this.content = data?.report?.response ?? ""
      } catch (e) {
        this.isLoading = false
        throw new Error(e)
      }
      this.isLoading = false
    },
    getFilenameFromContentDisposition(contentDisposition, defaultName = "file") {
      if ( !contentDisposition) return defaultName
      const matches = contentDisposition?.match(/filename="([^"]+)"/)
      if (matches && matches.length > 1) {
        return matches[1]
      }
      return defaultName
    },

    async exportPDF() {
      this.isExporting = true
      try {
        const {
          data,
          headers,
        } = await this.$axios.get(`ai-request-sets/${this.report_id}/pdf`, {
          responseType: "blob",
        })
        const fileName = this.getFilenameFromContentDisposition(headers["content-disposition"])
        const file = new Blob([data], { type: headers["content-type"] })
        const url = URL.createObjectURL(file)
        const link = document.createElement("a")
        link.href = url
        link.setAttribute("download", fileName)
        link.target = "_blank"
        document.body.appendChild(link)
        link.click()
        setTimeout(() => {
          link.remove()
          URL.revokeObjectURL(url)
        })
      } catch (e) {
        console.error(e)
        throw e
      } finally {
        this.isExporting = false
      }
    },

  },
}
</script>

